import { Firestore } from "../lib/firebase";
import { v4 as uuidv4 } from 'uuid';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

toast.configure({
  autoClose: 2000,
  draggable: false
});
const { map } = require("p-iteration");



export const getUserById = codeId =>
    new Promise(async (resolve, reject) => {
        let codeDoc = Firestore.collection("users").doc(codeId);
        let snapshot = await codeDoc.get();
        let codeData = snapshot.data();
        let boxes = await getProductsByUser(codeId);
        codeData.id = codeId;
        codeData.boxes = boxes;
        resolve(codeData);
    });

export const setLogById = (codeId, action, data) =>
    new Promise(async (resolve, reject) => {
        let codeDoc = Firestore.collection(`users/${codeId}/logs`).doc();
        if (action.toLowerCase() === 'to storage') {
            const logData = {
                action,
                date: new Date(),
                products: data
            }
            codeDoc.set(logData);
        }
        if (action.toLowerCase() === 'box created') {
            const { userId, itemId, productIds } = data;
            const logData = {
                action,
                userId,
                boxId: itemId,
                date: new Date(),
                products: productIds
            }
            codeDoc.set(logData);
        }
        if (action.toLowerCase() === 'processed returns') {
            const { userId, boxId, productIds } = data;
            const logData = {
                action,
                date: new Date(),
                userId,
                boxId,
                products: productIds
            }
            codeDoc.set(logData);
        }
        let snapshot = await codeDoc.get();
        let codeData = snapshot.data();
        resolve(codeData);
    });

export const getLogByBoxId = (barcode, boxId) => {
    return Firestore.collection('products')
        .doc(barcode).collection('logs')
        .where('boxID', '==', boxId)
        .get()
        .then((results) => {
            const items = [];
            for (const doc of results.docs) {
                const item = doc.data();
                item.id = doc.id;
                item.barcode = barcode;
                items.push(item);
            }

            return items[0];
        })
        .catch((error) => {
            throw new Error(error);
        });
}

// search codes with the criteria
export const getUsers = async () => {
    let codeCollection = Firestore.collection("users");

    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getUserById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const setLogsByUid = async (uid, action, data) => {
    let codeCollection = Firestore.collection("users").where('uid', '==', uid);

    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => setLogById(codeDoc.id, action, data));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getAdminUsers = async () => {
    let codeCollection = Firestore.collection("config").doc('roles');

    try {
        let snapshot = await codeCollection.get();
        return snapshot.data();
    } catch (error) {
        throw error;
    }
};

export const getOnePageUsers = async (increase, itemsPerPage, country) => {

    const field = 'first_name';
    let codeCollection =
        Firestore.collection("users")
            .where('country', '==', country)
            .orderBy(field).limit(itemsPerPage);
    if (increase === true && window.lastItem) {
        codeCollection =
            Firestore.collection("users")
                .where('country', '==', country)
                .orderBy(field).startAfter(window.lastItem).limit(itemsPerPage);
    }

    try {
        let snapshot = await codeCollection.get();
        window.lastItem = snapshot.docs[snapshot.docs.length - 1];
        let tasks = snapshot.docs.map(codeDoc => getUserById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};
export const getOnePageUsersForStylist = async (increase, itemsPerPage, uid) => {

    const field = 'first_name';
    let codeCollection = Firestore.collection("users")
        .where('current_stylist', '==', uid)
        .orderBy(field)
        .limit(itemsPerPage);
    if (increase === true && window.lastItem) {
        codeCollection = Firestore.collection("users")
            .where('current_stylist', '==', uid)
            .orderBy(field)
            .startAfter(window.lastItem)
            .limit(itemsPerPage);
    }

    try {
        let snapshot = await codeCollection.get();
        window.lastItem = snapshot.docs[snapshot.docs.length - 1];
        let tasks = snapshot.docs.map(codeDoc => getUserById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};
export const getUsersByQuery = async (search, itemsPerPage, country) => {

    //const secondary = String.fromCharCode(search.charCodeAt(0) + 1);
    const query = search.charAt(0).toUpperCase() + search.slice(1);
    const secondary = secondQuery(query);
    let codeCollection = Firestore.collection("users")
        .where('full_name', '>=', query)
        .where('full_name', '<', secondary)
        .where('country', '==', country)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getUserById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getUsersByFieldQuery = async (field, search, itemsPerPage, country, transformCase = true) => {
    const query = transformCase ? search.charAt(0).toUpperCase() + search.slice(1) : search;
    const secondary = secondQuery(query);

    let codeCollection = Firestore.collection("users")
        .where(field, '>=', query)
        .where(field, '<', secondary)
        .where('country', '==', country)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getUserById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getUsersByQueryForStylist = async (search, uid, itemsPerPage) => {

    //const secondary = String.fromCharCode(search.charCodeAt(0) + 1);
    const query = search.charAt(0).toUpperCase() + search.slice(1);
    const secondary = secondQuery(query);
    let codeCollection = Firestore.collection("users")
        .where('full_name', '>=', query)
        .where('full_name', '<', secondary)
        .where('current_stylist', '==', uid)
        .where('current_stylist', '==', uid)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getUserById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getUsersByFieldQueryForStylist = async (field, search, uid, itemsPerPage, transformCase = true) => {

    const query = transformCase ? search.charAt(0).toUpperCase() + search.slice(1) : search;
    const secondary = secondQuery(query);

    let codeCollection = Firestore.collection("users")
        .where(field, '>=', query)
        .where(field, '<', secondary)
        .where('current_stylist', '==', uid)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getUserById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getStylistsByQuery = async (search, itemsPerPage, country) => {

    //const secondary = String.fromCharCode(search.charCodeAt(0) + 1);
    const query = search.charAt(0).toUpperCase() + search.slice(1);
    const secondary = secondQuery(query);
    let codeCollection = Firestore.collection("employees")
        .where('first_name', '>=', query)
        .where('first_name', '<', secondary)
        .where('country', '==', country)
        .where('role', '==', 'stylist')
        .limit(itemsPerPage);

    try {
        const snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map((codeDoc) => {
            const data = codeDoc.data();
            data.id = codeDoc.id;
            return data;
        });
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getBarcodesByQuery = async (search, itemsPerPage) => {

    const secondary = secondQuery(search)
    let codeCollection = Firestore.collection("products")
        .where('barcode', '>=', search)
        .where('barcode', '<', secondary)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getBarcodeById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getClosetPreviewProducts = async () => {
    const codeCollection = Firestore.collection("products")
        .where('is_preview', '==', true)
        .limit(400);

    try {
        const res = await codeCollection.get();
        return res.docs.map((doc) => Object({ id: doc.id, ...doc.data() }));
    } catch (error) {
        throw new Error(error.message);
    };
}

export const getProductByFieldQuery = async (field, search, itemsPerPage, market) => {

    const secondary = secondQuery(search)
    let codeCollection = Firestore.collection("products")
        .where(field, '>=', search)
        .where(field, '<', secondary)
        .where('market', '==', market)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getBarcodeById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        console.log(error.message);
    }
};

export const getAvailableProductByFieldQuery = async (field, search, itemsPerPage, market) => {

    const secondary = secondQuery(search)
    let codeCollection = Firestore.collection("products")
        .where(field, '>=', search)
        .where(field, '<', secondary)
        .where('market', '==', market)
        .where('status', '==', 'available')
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getBarcodeById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getProductByFieldQueryIncludes = async (field, search, itemsPerPage, market) => {

    let codeCollection = Firestore.collection("products")
        .where(field, 'array-contains', search)
        .where('market', '==', market)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getBarcodeById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getBarcodesByWash = async (barcode, userId, itemsPerPage) => {
    let codeCollection = Firestore.collection("products")
        .where('barcode', '==', barcode)
        .where('status', 'in', ['at_customer', 'kept', 'missing'])
        .where('currentUser', '==', userId)
        .limit(itemsPerPage);
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getBarcodeById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getProductLogs = async productId => {
    let codeCollection = Firestore.collection(
        `products/${productId}/logs`
    ).orderBy("addedToBox", "desc");
    try {
        let snapshot = await codeCollection.get();
        let logs = [];
        await map(snapshot.docs, async codeDoc => {
            let data = codeDoc.data();
            logs.push(data);
        });

        return logs;
    } catch (error) {
        throw error;
    }
};
export const updateProductFields = async ({ barcode, payload }) => {
    await Firestore.collection(`products`).doc(barcode)
        .update(payload);
}
export const updateLogById = async ({ barcode, currentBox, payload }) => {
    await Firestore.collection(`products`).doc(barcode).collection('logs').doc(currentBox)
        .update(payload);
}

export const barcodeIsNew = codeId =>
    new Promise(async (resolve, reject) => {
        let codeDoc = Firestore.collection("products").doc(codeId);
        let snapshot = await codeDoc.get();
        let codeData = snapshot.data();
        if (codeData === undefined) {
            resolve(true);
        } else {
            reject(false);
        }
    })
        .catch((err) => {
            return err;
        });

export const getBarcodeById = codeId =>
    new Promise(async (resolve, reject) => {
        let codeDoc = Firestore.collection("products").doc(codeId);
        let snapshot = await codeDoc.get();
        let codeData = snapshot.data();
        let logs = await getProductLogs(codeId);
        codeData.id = codeId;
        codeData.logs = logs;
        resolve(codeData);
    });

export const getBarcodeOnly = async (codeId) => {
    let codeDoc = Firestore.collection("products").doc(codeId);
    let snapshot = await codeDoc.get();
    let codeData = snapshot.data();
    if (codeData === undefined) throw new Error("This product doesn't exist. Please enter a valid barcode.");

    codeData.id = codeId;
    return codeData;
}

export const getBarcodes = async () => {
    let codeCollection = Firestore.collection("products");
    try {
        let snapshot = await codeCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getBarcodeById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};
export const getOnePageBarcodes = async (increase, itemsPerPage, market) => {

    const field = 'barcode';
    let codeCollection =
        Firestore.collection("products")
            .where('market', '==', market)
            .orderBy(field).limit(itemsPerPage);
    if (increase === true && window.lastBarcode) {
        codeCollection =
            Firestore.collection("products")
                .where('market', '==', market)
                .orderBy(field).startAfter(window.lastBarcode).limit(itemsPerPage);
    }
    try {
        let snapshot = await codeCollection.get();
        window.lastBarcode = snapshot.docs[snapshot.docs.length - 1];
        let tasks = snapshot.docs.map(codeDoc => getBarcodeById(codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};


export const getProductsByUser = async userId => {
    let boxCollection = Firestore.collection(`users/${userId}/boxes`);
    try {
        let snapshot = await boxCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getItemsById(userId, codeDoc.id));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getProductsByUserAndCode = async (userId, barcode) => {
    let boxCollection = Firestore.collection(`users/${userId}/boxes`);
    try {
        let snapshot = await boxCollection.get();
        let tasks = snapshot.docs.map(codeDoc => getItemsByIdAndCode(userId, codeDoc.id, barcode));
        let codes = Promise.all(tasks);
        return codes;
    } catch (error) {
        throw error;
    }
};

export const getItemByBarcode = async (userId, boxId, barcode) => {
    let itemCollection = Firestore.collection(
        `users/${userId}/boxes/${boxId}/items`)
        .where('barcode', '==', barcode);
    try {
        let snapshot = await itemCollection.get();
        let doc = snapshot.docs[0]
        let item = doc.data();
        item.id = doc.id;
        return item;
    } catch (error) {
        return error;
    }
};

export const getItemsById = async (userId, itemId) => {
    let itemCollection = Firestore.collection(
        `users/${userId}/boxes/${itemId}/items`
    );
    let userRef = await Firestore.collection("users")
        .doc(userId)
        .get();
    let user = await userRef.data();

    try {
        let snapshot = await itemCollection.get();
        let box = {};
        let codes = [];
        await map(snapshot.docs, async codeDoc => {
            let code = await getItemById(userId, itemId, codeDoc.id);
            codes.push(code);
        });

        box.email = user.email || "";
        box.boxCount = snapshot.docs.length || 0;
        box.boxId = itemId || "";
        box.product1Feedback = (codes[0] && codes[0].feedback) || "";
        box.product2Feedback = (codes[1] && codes[1].feedback) || "";
        box.product3Feedback = (codes[2] && codes[2].feedback) || "";
        box.product4Feedback = (codes[3] && codes[3].feedback) || "";
        box.product5Feedback = (codes[4] && codes[4].feedback) || "";

        box.barcode1 = (codes[0] && codes[0].barcode) || "";
        box.barcode2 = (codes[1] && codes[1].barcode) || "";
        box.barcode3 = (codes[2] && codes[2].barcode) || "";
        box.barcode4 = (codes[3] && codes[3].barcode) || "";
        box.barcode5 = (codes[4] && codes[4].barcode) || "";

        box.product1Name = (codes[0] && codes[0].name) || "";
        box.product2Name = (codes[1] && codes[1].name) || "";
        box.product3Name = (codes[2] && codes[2].name) || "";
        box.product4Name = (codes[3] && codes[3].name) || "";
        box.product5Name = (codes[4] && codes[4].name) || "";
        box.items = codes;
        return box;
    } catch (error) {
        throw error;
    }
};

export const getItemsByIdAndCode = async (userId, itemId, barcode) => {
    let itemCollection = Firestore.collection(
        `users/${userId}/boxes/${itemId}/items`)
        .where('barcode', '==', barcode);
    let userRef = await Firestore.collection("users")
        .doc(userId)
        .get();
    let user = await userRef.data();

    try {
        let snapshot = await itemCollection.get();
        let box = {};
        let codes = [];
        await map(snapshot.docs, async codeDoc => {
            let code = await getItemById(userId, itemId, codeDoc.id);
            codes.push(code);
        });

        box.email = user.email || "";
        box.boxCount = snapshot.docs.length || 0;
        box.boxId = itemId || "";
        box.product1Feedback = (codes[0] && codes[0].feedback) || "";
        box.product2Feedback = (codes[1] && codes[1].feedback) || "";
        box.product3Feedback = (codes[2] && codes[2].feedback) || "";
        box.product4Feedback = (codes[3] && codes[3].feedback) || "";
        box.product5Feedback = (codes[4] && codes[4].feedback) || "";

        box.barcode1 = (codes[0] && codes[0].barcode) || "";
        box.barcode2 = (codes[1] && codes[1].barcode) || "";
        box.barcode3 = (codes[2] && codes[2].barcode) || "";
        box.barcode4 = (codes[3] && codes[3].barcode) || "";
        box.barcode5 = (codes[4] && codes[4].barcode) || "";

        box.product1Name = (codes[0] && codes[0].name) || "";
        box.product2Name = (codes[1] && codes[1].name) || "";
        box.product3Name = (codes[2] && codes[2].name) || "";
        box.product4Name = (codes[3] && codes[3].name) || "";
        box.product5Name = (codes[4] && codes[4].name) || "";
        box.items = codes;
        return box;
    } catch (error) {
        throw error;
    }
};

export const getItemById = (userId, boxId, itemId) =>
    new Promise(async (resolve, reject) => {
        let codeDoc = Firestore.collection(
            `users/${userId}/boxes/${boxId}/items`
        ).doc(itemId);
        let snapshot = await codeDoc.get();
        let codeData = snapshot.data();
        codeData.id = itemId;
        resolve(codeData);
    });

export const updateItemFeedback = (userId, boxId, itemId, feedback) =>

    new Promise(async (resolve, reject) => {
        let codeDoc = Firestore.collection(
            `users/${userId}/boxes/${boxId}/items`
        ).doc(itemId);
        codeDoc.update({
            feedback
        });

        let itemDoc = Firestore.collection(
            `users/${userId}/boxes`
        ).doc(boxId);
        itemDoc.update({
            feedbackSaved: true
        })
        resolve(true);
    });


export const updateItem = (userId, boxId, itemId, payload) => {
    return Firestore.collection('users').doc(userId)
        .collection('boxes').doc(boxId)
        .collection('items').doc(itemId)
        .set(payload, { merge: true })
        .catch((error) => {
            throw new Error(error)
        });
}

export const updateBoxInfo = (userId, boxId, payload) => {
    return Firestore.collection('users')
        .doc(userId).collection('boxes')
        .doc(boxId)
        .update(payload)
        .catch((error) => {
            throw new Error(error)
        });
}

export const updateBoxInvestigateStatus = (lateBox, type) => {
    return Firestore.collection('users')
        .doc(lateBox.userID).collection('boxes')
        .doc(lateBox.id)
        .update({
            [type]: +new Date()
        })
        .catch((error) => {
            throw new Error(error)
        });
}

export const updateProductStatus = (codeId, status) =>
    new Promise((resolve, reject) => {
        let codeDoc = Firestore.collection("products").doc(codeId);
        codeDoc.update({ status: status });
        resolve(true);
    });

export const updateProductLog = (codeId, boxId, type) =>
    new Promise((resolve, reject) => {
        Firestore.collection(`products/${codeId}/logs`)
            .doc(boxId)
            .update({
                [type]: +new Date()
            });

        resolve(true);
    });

export const updateReports = (report, type, role) => {
    const timestamp = +new Date();
    Firestore.collection(`products/${report.barcode}/reports`)
        .doc(report.id)
        .update({
            [type]: {
                at: timestamp,
                by: role
            }
        });
}

export const closeReports = (report, type, option, role) => {
    const timestamp = +new Date();
    Firestore.collection(`products/${report.barcode}/reports`)
        .doc(report.id)
        .update({
            [type]: {
                at: timestamp,
                by: role
            },
            status: option
        });
}

export const updateProductCurrentUser = (codeId, userId) =>
    new Promise((resolve, reject) => {
        let codeDoc = Firestore.collection("products").doc(codeId);
        codeDoc.update({
            currentUser: userId
        });
        resolve(true);
    });

export const updateProductToAvailableStatus = (codeId, cycles) =>
    new Promise((resolve, reject) => {
        let codeDoc = Firestore.collection("products").doc(codeId);
        codeDoc.update({
            cycles: cycles,
            status: "available",
            currentBox: null
        });
        resolve(true);
    });

export const backToCloset = (barcode) => {
    let codeDoc = Firestore.collection("products").doc(barcode);
    try {
        codeDoc.update({
            status: "available",
            currentBox: null,
            currentUser: null
        });
    } catch (error) {
        return error;
    }
}

export const addUserFeedback = (userId, itemId, imageURL, feedback) =>
    new Promise((resolve, reject) => {
        let feedbackItem;
        switch (feedback) {
            case 'Liked it':
                feedbackItem = "liked_items";
                break;
            case 'Not my style':
                feedbackItem = "unliked_items";
                break;
            case 'Too big':
                feedbackItem = "too_big";
                break;
            case 'Too small':
                feedbackItem = "too_small";
                break;
            case 'Kept for 1 more month':
                feedbackItem = "kept1month";
                break;
            case 'Kept for 6 more months':
                feedbackItem = "kept6months";
                break;
            default:
                break;
        }
        let codeDoc = Firestore.collection(`users/${userId}/${feedbackItem}/`).doc();
        codeDoc.set({
            documentID: itemId,
            imageURL
        });
        resolve(true);
    });

export const addProducts = async ({ user, barcodes, return_date, shipment_week, status, box_type }) => {
    let userId = user.id;


    let userEmail = user.email || "";
    let lastSerial = 0;

    try {
        const itemId = uuidv4();

        let userProductRef = Firestore.collection(`users/${userId}/boxes`).doc(
            itemId
        );

        let notification = [];
        let firstime = getDateBySubstract(1);
        let secondtime = getDateBySubstract(25);
        notification.push(firstime);
        notification.push(secondtime);

        await userProductRef.set({
            createdAt: new Date(),
            feedbackSaved: false,
            return_date,
            shipment_week,
            status,
            box_type
        });

        await Firestore.collection("notifications")
            .doc(itemId)
            .set({
                first: firstime.getTime(),
                second: secondtime.getTime(),
                boxId: itemId,
                userId: userId
            });

        let userProductCollectionItemRef = Firestore.collection(
            `users/${userId}/boxes/${itemId}/items`
        );
        await map(barcodes, async product => {
            lastSerial++;
            await userProductCollectionItemRef.add({
                barcode: product.barcode,
                description: product.name,
                feedback: "",
                imageURL: product.imageURLs[0],
                name: product.name,
                boxId: itemId,
                serial: lastSerial,
                status: 'at_customer'
            });

            await Firestore.collection(`products/${product.id}/logs`)
                .doc(itemId)
                .set({
                    addedToBox: +new Date(),
                    boxID: itemId,
                    userID: userId,
                    userEmail: userEmail,
                    processedReturn: null,
                    toStorage: null,
                    return_date
                });

            await Firestore.collection(`products`)
                .doc(product.id)
                .update({
                    currentBox: itemId
                });

            await updateProductStatus(product.id, "at_customer");
            await updateProductCurrentUser(product.id, userId);
        });
        const productIds = await barcodes.map(item => item.id);
        await setLogsByUid(window.uid, 'Box created', { userId, itemId, productIds });
    } catch (error) {
        throw error;
    }
};


export function addUsersToStylist(stylist, customers) {
    const batch = Firestore.batch();
    for (const customer of customers) {
        const ref = Firestore.collection("users").doc(customer.id);
        batch.set(ref, { current_stylist: stylist.id }, { merge: true });
    }

    return batch.commit();
};

export const create = async payload => {
    try {
        await Firestore.collection("products")
            .doc(payload.barcode)
            .set(payload);
    } catch (error) {
        return error;
    }
};

/**
 * Getting product from database
 * @param {*} productId
 * @param {*} callback (error, result)
 */
export async function getProduct(productId) {
    return Firestore.collection("products")
        .doc(productId)
        .get()
        .then((result) => {
            return result.data();
        })
        .catch((error) => {
            throw new Error(error);
        });
};

/**
 *
 * @param {*} productId
 * @param {*} payload
 * @param {*} callback
 */
export async function editProduct(barcode, payload, callback = () => { }) {
    Firestore.collection("products")
        .doc(barcode)
        .set(payload, { merge: true })
        .then(result => {
            callback();
        })
        .catch(error => {
            console.error("Error editing document: ", error);
        });
}

export async function deleteProduct(productId, callback = () => { }) {
    Firestore.collection("products")
        .doc(productId)
        .delete()
        .then((result) => {
            callback();
        })
        .catch(error => {
            console.error("Error deleting document: ", error);
        });
}
export function deleteProductById(id, setData,isDeleting,setIsDeleting) {

    if (isDeleting) {
      return;
    }
  
    setIsDeleting(true);
  
    const docRef = Firestore.collection("products").doc(id);
  
    docRef.delete()
      .then(() => {
        setData(prevData => prevData.filter(item => item.id !== id));
        toast.success("Product deleted successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      })
      .finally(() => {
        setIsDeleting(false);
      });
  }
export async function createProductLog(productId, boxID, payload, callback = () => { }) {
    Firestore.collection("products")
        .doc(productId)
        .collection("logs")
        .doc(boxID)
        .set(payload)
        .then(() => {
            callback();
        })
        .catch(error => {
            console.error("Error creating document: ", error);
        });
}

export function deleteProductLog(productId, logId) {
    return Firestore.collection("products").doc(productId)
        .collection("logs").doc(logId)
        .delete()
        .catch((error) => {
            console.error("Error deleting logs: ", error);
        });
}

export function deleteProductReport(productId, reportId) {
    return Firestore.collection("products").doc(productId)
        .collection("reports").doc(reportId)
        .delete()
        .catch((error) => {
            console.error("Error deleting reports: ", error);
        });
}


export function getProductLogByBoxId(productId, boxId) {
    return Firestore.collection("products").doc(productId)
        .collection("logs").doc(boxId)
        .get()
        .then((result) => {
            const log = result.data();
            log.id = result.id;

            return log;
        })
        .catch((error) => {
            return error;
        })
}

export const setProductLogByBoxId = async (productId, boxId, payload) => {
    const productCollection = Firestore.collection("products").doc(productId)
        .collection("logs").doc(boxId);

    try {
        const result = await productCollection.set(payload, { merge: true })
        const log = result.data();
        log.id = result.id;
        return log;
    }
    catch (error) {
        return error;
    }
}

export const getReportsByProductBarcode = async (barcode) => {
    const res = await Firestore.collection('products')
        .doc(barcode)
        .collection('reports')
        .get();

    return res.docs.map((report) => Object({ id: report.id, ...report.data() }));
}

export const getReportsByBarcode = async (barcode) => {
    const codeCollection = Firestore.collection("products").doc(barcode)
        .collection("reports")

    try {
        const snapshot = await codeCollection.get();
        const reports = [];
        for (const doc of snapshot.docs) {
            const report = doc.data();
            report.id = doc.id;
            const product = await getProductByBarcode(report.barcode);
            report.market = product.market;
            if (product.currentUser) {
                const user = await getUserById(product.currentUser);
                report.user = user;
                report.product = product;
            };
            reports.push(report);
        }
        return reports;
    } catch (error) {
        return error;
    }
}


export const getDamageProducts = async (market) => {
    const reportsRef = Firestore.collectionGroup('reports')
        .where('status', '==', 'reported');

    try {
        const snapshot = await reportsRef.get();

        const reports = [];
        for (const doc of snapshot.docs) {
            const report = { id: doc.id, ...doc.data() };
            const product = (await doc.ref.parent.parent.get()).data();

            report.market = product.market;
            if (report.market === market) {
                if (product.currentUser) {
                    const user = await getUserById(product.currentUser);
                    report.user = user;
                    report.product = product;
                };
                reports.push(report);
            };
        }
        return reports;
    } catch (error) {
        return error;
    }
}

export function setRepairsReport(payload) {
    return Firestore.collection('products').doc(payload.barcode)
        .collection('reports').doc()
        .set(payload, { merge: true })
        .catch((error) => {
            console.error(error);
            return error;
        })
}

export function getDateBySubstract(subtractDays) {
    const date = new Date();
    const last = new Date(date.getTime() + subtractDays * 24 * 60 * 60 * 1000);
    return last;
}

export const getBarcode = async (barcode, market = 'Sweden') => {

    if (!barcode) {
        return;
    }

    const res = await Firestore.collection('products')
        .where('barcode', '==', barcode)
        .where('market', '==', market)
        .get();

    return res.docs.map((item) => Object({ id: item.id, ...item.data() }))[0];
};

const secondQuery = text => {
    const lastLetter = String.fromCharCode(text.charCodeAt(text.length - 1) + 1);
    const query = text.slice(0, -1) + lastLetter;
    return query;
}

export async function getLateBoxes(market) {
    const codeCollection = Firestore.collectionGroup("boxes")
        .where('status', '==', 'late')
        .limit(50);

    try {
        const snapshot = await codeCollection.get();

        const boxes = [];
        const users = {};
        for (const doc of snapshot.docs) {
            const box = doc.data();
            box.id = doc.id;
            box.userID = doc.ref.path.split('/')[1]
            if (!users[box.userID]) {
                users[box.userID] = await getUserById(box.userID);
            }
            box.user = users[box.userID]

            box.isCharged = box.is_charged ? box.is_charged : false;
            if (box.user.stripe?.late_box_subscriptions) {
                box.isCharged = box.user.stripe.late_box_subscriptions.some((sub) => sub.box_id === box.id);
            }

            if (box.user.country === market) { boxes.push(box); };
        }
        return boxes;
    } catch (error) {
        throw error;
    }

}

export async function getReturnedLateBoxes(market) {
    const codeCollection = Firestore.collectionGroup('boxes')
        .orderBy('declared_returned', 'asc');

    try {
        const snapshot = await codeCollection.get();
        const boxes = [];
        for (const doc of snapshot.docs) {
            const box = doc.data();
            box.id = doc.id;
            box.userID = doc.ref.path.match(/[\d\w]{20}/)[0];
            box.user = await getUserById(box.userID);

            if (box.user.country === market) { boxes.push(box); };
        }
        return boxes;
    } catch (error) {
        throw error;
    }

}

export const getMissingItems = async (market) => {
    const res = await Firestore.collection('products')
        .where('market', '==', market)
        .where('status', '==', 'missing')
        .limit(50)
        .get();

    const products = [];
    for (const doc of res.docs) {
        const product = doc.data();
        product.id = doc.id;
        products.push(product);
    }

    return res.docs.map((doc) => Object({ id: doc.id, ...doc.data() }));
}

export const getItemsByFieldQuery = async ({ option, search, market }) => {
    try {
        const res = await Firestore.collection("products")
            .where('market', '==', market)
            .where('status', '==', option)
            .where('currentUser', '==', search)
            .limit(50)
            .get()
        return res.docs.map((doc) => Object({ id: doc.id, ...doc.data() }));
    } catch (error) {
        throw error;
    }
};

export function getKeptItems(market) {
    return Firestore.collection('products')
        .where('market', '==', market)
        .where('status', '==', 'kept')
        .limit(50)
        .get()
        .then((results) => {
            const products = [];
            for (const doc of results.docs) {
                const product = doc.data();
                product.id = doc.id;
                products.push(product);
            }

            return products;
        })
        .catch((error) => {
            throw new Error(error);
        });
}


export function setFeedBack(payload, userID, boxID) {
    return Firestore.collection('users').doc(userID)
        .collection('boxes').doc(boxID)
        .set(payload, { merge: true })
        .then((result) => {
            const log = result.data();
            log.id = result.id;

            return log;
        })
        .catch((error) => {
            return error;
        })
}


export function getProductByBarcode(barcode) {
    return Firestore.collection('products').doc(barcode).get()
        .then((result) => {
            return { id: result.id, ...result.data() };
        })
        .catch((error) => {
            throw new Error(error);
        })
}

export const setProduct = async (barcode, payload) => {
    await Firestore.collection('products')
        .doc(barcode).update(payload);
}
